import { useFlipIntoPlace } from '@/hooks/questions/dnd/useFlipIntoPlace';
import { DnDToken } from '@/utils/questions/dnd/types';
import { Draggable } from '@hello-pangea/dnd';
import { useCallback } from 'react';
import { ChipBox } from './ChipBox';
import { useDragDropAnswerContext } from './DragDropAnswerContext';

type OptionChipProps = {
  token: DnDToken;
  index: number;
  className?: string;
  fadingOut?: boolean;
};

export function OptionChip({
  token,
  index,
  className,
  fadingOut,
}: OptionChipProps) {
  const { disabled, flipFrom, clearFlip, selectedId, onChipClick, flow } =
    useDragDropAnswerContext();
  const testId = `chip-${token.id}`;
  const flip = flipFrom[String(token.id)];
  const onFlipDone = useCallback(
    () => clearFlip(String(token.id)),
    [clearFlip, token.id],
  );
  const selected = selectedId === String(token.id);

  useFlipIntoPlace({
    testId,
    from: flip?.rect,
    fadeIn: flip?.fromSlot,
    onDone: onFlipDone,
  });

  return (
    <Draggable
      draggableId={String(token.id)}
      index={index}
      isDragDisabled={disabled}
      disableInteractiveElementBlocking
    >
      {(provided, snapshot) => (
        <ChipBox
          token={token}
          provided={provided}
          snapshot={snapshot}
          disabled={disabled}
          flow={flow}
          testId={testId}
          className={className}
          fadingOut={fadingOut}
          selected={selected}
          onSelect={() => onChipClick(String(token.id))}
        />
      )}
    </Draggable>
  );
}
